import { renderActionsCell } from '@/modules/admin-access-codes/row/renderActions';
import { renderCodeCell } from '@/modules/admin-access-codes/row/renderCode';
import { renderDateCell } from '@/modules/admin-access-codes/row/renderDate';
import { renderStatusCell } from '@/modules/admin-access-codes/row/renderStatus';

export const getAccessCodesColumns = (t) => [
  {
    field: 'code',
    headerName: t('Code'),
    flex: 1.4,
    minWidth: 260,
    sortable: false,
    renderCell: renderCodeCell,
  },
  {
    field: 'status',
    headerName: t('Status'),
    flex: 0.8,
    minWidth: 160,
    sortable: true,
    renderCell: renderStatusCell,
  },
  {
    field: 'resellerName',
    headerName: t('Reseller'),
    flex: 1.2,
    minWidth: 260,
    sortable: true,
  },
  {
    field: 'createdAt',
    headerName: t('Created'),
    flex: 0.9,
    minWidth: 180,
    sortable: true,
    renderCell: renderDateCell,
  },
  {
    field: 'redeemedAt',
    headerName: t('Redeemed'),
    flex: 0.9,
    minWidth: 180,
    sortable: true,
    renderCell: renderDateCell,
  },
  {
    field: 'actions',
    headerName: '',
    width: 72,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'right',
    renderCell: renderActionsCell,
  },
];
